import { render, staticRenderFns } from "./treatments-list.vue?vue&type=template&id=24a5ed12&"
import script from "./treatments-list.vue?vue&type=script&lang=js&"
export * from "./treatments-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports